module.exports = new __parcel__URL__("go_raiding_button.3ed8709a.png").toString();